import React, { useState } from "react";
import { m as motion } from "../../shared/components/Motion";
import "./home.css";
import Social from "./Social";
import Data from "./Data";
import ScrollDown from "./ScrollDown";
import HomeSkeleton from "./HomeSkeleton";
import { useHomeData } from "../../shared/hooks";
import { useAdmin } from "../../features/admin/AdminProvider";
import EditHomeModal from "../../features/admin/modals/EditHomeModal";
import { cld } from "../../shared/utils";

// Resolves either a Cloudinary public ID or a legacy full URL.
const resolveImg = (val, width) => {
  if (!val) return "";
  if (val.startsWith("http")) return val;
  return cld(val, width);
};

const Home = () => {
  const { data, loading } = useHomeData();
  const { adminMode, isAdmin, homeDraft } = useAdmin();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageError, setImageError] = useState(false);

  // Use draft ONLY if admin is authenticated, otherwise use published data
  const displayData = isAdmin && homeDraft ? homeDraft : data || {};

  const handleEditHome = () => {
    setIsModalOpen(true);
  };

  const handleSaveEntry = () => {
    setIsModalOpen(false);
  };

  // Show skeleton while loading
  if (loading || !displayData.title) {
    return <HomeSkeleton />;
  }

  return (
    <section className="home section" id="home">
      <div className="home__container container grid">
        <div className="home__content grid">
          <Social socialLinks={displayData.socialLinks} />
          <motion.div
            className="home__img"
            style={{
              backgroundImage: resolveImg(
                displayData.imageId || displayData.imageUrl,
                620,
              )
                ? `url(${resolveImg(displayData.imageId || displayData.imageUrl, 620)})`
                : "",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
              boxShadow: "inset 0 0 0 9px rgb(255 255 255 / 30%)",
              position: "relative",
            }}
          >
            {imageError && (
              <div className="image-error__others home-img__skeleton">
                <i className="uil uil-image-slash"></i>
              </div>
            )}
            <img
              src={resolveImg(displayData.imageId || displayData.imageUrl, 560)}
              alt="home-profile"
              width="280"
              height="280"
              fetchpriority="high"
              onError={() => setImageError(true)}
              style={{ display: "none" }}
            />
            {adminMode && (
              <motion.button
                onClick={handleEditHome}
                whileHover={{ scale: 1.15 }}
                whileTap={{ scale: 0.9 }}
                style={{
                  position: "absolute",
                  bottom: "0",
                  right: "-2rem",
                  borderRadius: "50%",
                  width: "36px",
                  height: "36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  color: "var(--body-color)",
                  padding: "0px",
                  background: "var(--title-color)",
                }}
                title="Edit home section"
              >
                <i className="bx bx-pencil"></i>
              </motion.button>
            )}
          </motion.div>
          <Data data={displayData} />
        </div>
        <ScrollDown />
      </div>

      {/* Edit Home Modal */}
      <EditHomeModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleSaveEntry}
        homeData={displayData}
        publishedData={data}
      />
    </section>
  );
};

export default Home;
